// removed by extract-text-webpack-plugin
module.exports = {"option":"sideNav_option_22GGx"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/SideNav/sideNav.css
// module id = 346
// module chunks = 0